import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/Layout";
import Hero from "../components/Hero";
import Features from "../components/Features";
import HowItWorks from "../components/HowItWorks";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import PricingTable from "../components/PricingTable";
import ProblemSolution from "../components/ProblemSolution";
import ResumeTemplates from "../components/ResumeTemplates";
import CoverLetterBuilder from "../components/CoverLetterTemplates";
import OneClickGenerator from "../components/OneClickGenerator";
import ProductDemo from "../components/ProductDemo";

const IndexPage = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "ResumeFlex",
    "url": "https://www.resumeflex.com",
    "logo": "https://www.resumeflex.com/images/logo.png",
    "description": "ResumeFlex is an AI-powered platform designed to streamline job applications with one-click document generation and AI-powered customization.",
    "sameAs": [
      "https://www.facebook.com/ResumeFlex",
      "https://www.linkedin.com/company/resumeflex",
      "https://twitter.com/ResumeFlex"
    ]
  };

  return (
    <Layout>
      <Hero />
      <ProductDemo />
      <ProblemSolution />
      <OneClickGenerator />
      <ResumeTemplates />
      <CoverLetterBuilder />
      <Features />
      <HowItWorks />
      {/* <Testimonials /> */}
      <PricingTable />
      <FAQ />
    </Layout>
  );
};

export const Head = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "ResumeFlex",
    "url": "https://www.resumeflex.com",
    "logo": "https://www.resumeflex.com/images/logo.png",
    "description": "ResumeFlex is an AI-powered platform designed to streamline job applications with one-click document generation and AI-powered customization.",
    "sameAs": [
      "https://www.facebook.com/ResumeFlex",
      "https://www.linkedin.com/company/resumeflex",
      "https://twitter.com/ResumeFlex"
    ]
  };

  return (
    <>
      <title>ResumeFlex - AI-Powered Job Application Assistant</title>
      <meta
        name="description"
        content="ResumeFlex is an innovative AI-powered platform that streamlines job applications with one-click document generation, job-specific optimization, and AI-powered customization."
      />
      <meta
        name="keywords"
        content="ResumeFlex, AI resume builder, job applications, cover letters, AI-powered job applications"
      />

      {/* Open Graph */}
      <meta property="og:title" content="ResumeFlex - AI-Powered Job Application Assistant" />
      <meta
        property="og:description"
        content="ResumeFlex is an innovative AI-powered platform that streamlines job applications with one-click document generation, job-specific optimization, and AI-powered customization."
      />
      <meta property="og:image" content="https://www.resumeflex.com/images/home-banner.jpg" />
      <meta property="og:url" content="https://www.resumeflex.com" />
      <meta property="og:type" content="website" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="ResumeFlex - AI-Powered Job Application Assistant" />
      <meta
        name="twitter:description"
        content="ResumeFlex is an innovative AI-powered platform that streamlines job applications with one-click document generation, job-specific optimization, and AI-powered customization."
      />
      <meta name="twitter:image" content="https://www.resumeflex.com/images/home-banner.jpg" />

      {/* Additional Meta Tags */}
      <meta name="application-name" content="ResumeFlex" />
      <meta name="og:locale" content="en_US" />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData, null, 2)}
      </script>
    </>
  );
};

export default IndexPage;